import { z } from 'zod';

import { defineInvisible } from '@apps/web/features/phoebe_chat_v3/registry/types';

const payloadSchema = z.object({});

export const runCompletedDefinitions = {
    run_completed: defineInvisible('run_completed', {
        disposition: 'invisible',
        schema: payloadSchema,
        malformed: { kind: 'skip' },
        evidence(_payload, occurrence) {
            if (occurrence.committed === null) {
                return null;
            }
            return {
                kind: 'run_terminal',
                eventId: occurrence.committed.id,
                occurredAtMs: Date.parse(occurrence.committed.created_at),
            };
        },
    }),
} as const;

export const runCompletedContractFixtures = {
    valid: {
        type: 'run_completed',
    },
    malformed: [],
} as const;
